export const ICON_ALERT_TRIANGLE = 'ICON_ALERT_TRIANGLE';
export const ICON_CHECKMARK = 'ICON_CHECKMARK';
export const ICON_DISLIKE = 'ICON_DISLIKE';
export const ICON_GOLD_FLAME = 'ICON_GOLD_FLAME';
export const ICON_LIKE = 'ICON_LIKE';
export const ICON_PLATINUM_FLAME = 'ICON_PLATINUM_FLAME';
export const ICON_PRIMETIME_BOOST = 'ICON_PRIMETIME_BOOST';
export const ICON_SPOTIFY = 'ICON_SPOTIFY';
export const ICON_SUPERLIKE = 'ICON_SUPERLIKE';
export const ICON_TINDER = 'ICON_TINDER';
export const ICON_TINDER_U = 'ICON_TINDER_U';
